export default __webpack_public_path__ + "static/media/player.7ae63aae.svg";